import { Sviatok as SviatokDto, SviatokListExternalApi } from 'ciselniky-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ClientResponse } from '../../../model/ClientResponse';
import Sviatok from '../../../model/ciselniky/Sviatok';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';

const client = new SviatokListExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(sviatky: SviatokDto[]): Sviatok[] {
  return sviatky.map(it => ({
    nazov: it.nazov,
    datum: it.datum ? new Date(it.datum) : null,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchSviatky = async (headers?: object): Promise<ClientResponse<Sviatok[]>> => {
  const {
    data,
    status,
  } = await client.getSviatokList(headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
